// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__rchtl","footer":"ModalError_footer__CeWn2"};